<template>
  <v-app>
    <v-app-bar
        app
        color="primary"
        dark
    >
      <div class="d-flex align-center">
        <h1>Движение денег</h1>
      </div>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <v-form>
          <v-form class="ma-6 pa-0">
            <v-row>
              <v-col cols="3">
                <v-select
                    :items="contragents"
                    v-model="selectContragent"
                    label="Контрагент"
                    outlined
                    dense
                >
                </v-select>
              </v-col>
              <v-col cols="3">
                <v-select
                    :items="year"
                    v-model="selectYear"
                    label="Год"
                    outlined
                    dense
                >
                </v-select>
              </v-col>
              <!--              <v-col cols="2"
                                   sm="6"
                                   md="4"
                            >
                              <v-menu
                                  ref="menu"
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                      v-model="dates"
                                      label="Период"
                                      prepend-icon="mdi-calendar"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      outlined
                                      dense
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dates"
                                    range
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                      text
                                      color="primary"
                                      @click="menu = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                      text
                                      color="primary"
                                      @click="$refs.menu.save(dates)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>-->
            </v-row>
            <v-btn
            text
                color="success"
                class="mr-4"
                @click="getReport"
                :disabled="loading"
                small
            >
              Cформировать
            </v-btn>
            <v-btn
            text
                color="orange"
                class="mr-4"
                @click="exportXLS"
                :disabled="loading"
                small
            >
              EXPORT XLS
            </v-btn>
          </v-form>
        </v-form>

        <v-row>
          <v-col>
            <v-simple-table
                dense
                fixed-header
                height="600px"
            >
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left" v-for="item in headers"
                      :key="item">{{ item }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="orange">Поступления ПЛАН:</td>
                </tr>
                <StringTable
                    v-for="itemPlan in planData"
                    :key="itemPlan.id"
                    :item-data="itemPlan"></StringTable>
                <StringTable :item-data="totalPlan"></StringTable>
                <tr>
                  <td class="orange">Поступления ФАКТ:</td>
                </tr>
                <StringTable
                    v-for="itemFact in factData"
                    :key="itemFact.id"
                    :item-data="itemFact"></StringTable>
                <StringTable :item-data="totalFact"></StringTable>
                <StringTable :item-data="debit"></StringTable>
                <tr>
                  <td class="orange">Расходы ФАКТ:</td>
                </tr>
                <StringTable
                    v-for="itemCost in costData"
                    :key="itemCost.id"
                    :item-data="itemCost"></StringTable>
                <StringTable :item-data="totalCost"></StringTable>
                <StringTable :item-data="bdds"></StringTable>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import StringTable from "@/components/StringTable";
import axios from 'axios'
import exeljs from 'exceljs'
import fileWrite from 'file-saver'

export default {
  name: 'App',
  components: {StringTable},
  data: () => ({
    loading: false,
    contragents: [],
    selectContragent: '',
    year: ['2020', '2021', '2022'],
    selectYear: '',
    obj: [],
    dates: [],
    normalDate: [],
    menu: false,
    headers: [
      'Контрагент',
      'Объект',
      'Cумма договора',
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
      'Итого',
    ],
    bdds: {
      contragent: 'БАЛАНС БДДС: ',
      obj: '',
      docSum: 0,
      docSumVisible: '',
      january: 0,
      januaryVisible: '',
      february: 0,
      februaryVisible: '',
      marth: 0,
      marthVisible: '',
      april: 0,
      aprilVisible: '',
      may: 0,
      mayVisible: '',
      june: 0,
      juneVisible: '',
      jule: 0,
      juleVisible: '',
      august: 0,
      augustVisible: '',
      september: 0,
      septemberVisible: '',
      october: 0,
      octoberVisible: '',
      november: 0,
      novemberVisible: '',
      december: 0,
      decemberVisible: '',
      total: 0,
      totalVisible: '',
      color: 'success'
    },
    totalCost: {
      contragent: '',
      obj: 'Итого: ',
      docSum: 0,
      docSumVisible: '',
      january: 0,
      januaryVisible: '',
      february: 0,
      februaryVisible: '',
      marth: 0,
      marthVisible: '',
      april: 0,
      aprilVisible: '',
      may: 0,
      mayVisible: '',
      june: 0,
      juneVisible: '',
      jule: 0,
      juleVisible: '',
      august: 0,
      augustVisible: '',
      september: 0,
      septemberVisible: '',
      october: 0,
      octoberVisible: '',
      november: 0,
      novemberVisible: '',
      december: 0,
      decemberVisible: '',
      total: 0,
      totalVisible: '',
      color: 'success'
    },
    debit: {
      contragent: 'Дебиторка: ',
      obj: '',
      docSum: 0,
      docSumVisible: '',
      january: 0,
      januaryVisible: '',
      february: 0,
      februaryVisible: '',
      marth: 0,
      marthVisible: '',
      april: 0,
      aprilVisible: '',
      may: 0,
      mayVisible: '',
      june: 0,
      juneVisible: '',
      jule: 0,
      juleVisible: '',
      august: 0,
      augustVisible: '',
      september: 0,
      septemberVisible: '',
      october: 0,
      octoberVisible: '',
      november: 0,
      novemberVisible: '',
      december: 0,
      decemberVisible: '',
      total: 0,
      totalVisible: '',
      color: 'red'
    },
    totalFact: {
      contragent: '',
      obj: 'Итого: ',
      docSum: 0,
      docSumVisible: '',
      january: 0,
      januaryVisible: '',
      february: 0,
      februaryVisible: '',
      marth: 0,
      marthVisible: '',
      april: 0,
      aprilVisible: '',
      may: 0,
      mayVisible: '',
      june: 0,
      juneVisible: '',
      jule: 0,
      juleVisible: '',
      august: 0,
      augustVisible: '',
      september: 0,
      septemberVisible: '',
      october: 0,
      octoberVisible: '',
      november: 0,
      novemberVisible: '',
      december: 0,
      decemberVisible: '',
      total: 0,
      totalVisible: '',
      color: 'success'
    },
    totalPlan: {
      contragent: '',
      obj: 'Итого: ',
      docSum: 0,
      docSumVisible: '',
      january: 0,
      januaryVisible: '',
      february: 0,
      februaryVisible: '',
      marth: 0,
      marthVisible: '',
      april: 0,
      aprilVisible: '',
      may: 0,
      mayVisible: '',
      june: 0,
      juneVisible: '',
      jule: 0,
      juleVisible: '',
      august: 0,
      augustVisible: '',
      september: 0,
      septemberVisible: '',
      october: 0,
      octoberVisible: '',
      november: 0,
      novemberVisible: '',
      december: 0,
      decemberVisible: '',
      total: 0,
      totalVisible: '',
      color: 'success'
    },
    costData: [],
    factData: [],
    planData: [],
    url: 'https://citystroi.bitrix24.ru/rest/73/gjdt5g3y10jxw3r9/',
  }),
  methods: {
    async normalizeDate() {
      try {
        const firstDate = this.dates[0].split('-')
        const twoDate = this.dates[1].split('-')
        const firstDateFormated = firstDate[2] + '.' + firstDate[1] + '.' + firstDate[0] + ' 00:00:00'
        const twoDateFormated = twoDate[2] + '.' + twoDate[1] + '.' + twoDate[0] + ' 23:59:59'
        this.normalDate.push(firstDateFormated)
        this.normalDate.push(twoDateFormated)
      } catch (e) {
        console.log(e)
      }
    },
    async exportXLS() {
      try {
        const outBook = new exeljs.Workbook();
        outBook.views = [
          {
            x: 0,
            y: 500,
            width: 29040,
            height: 15840,
            visibility: 'visible'
          }
        ]
        const worksheet = outBook.addWorksheet('Движение денег');
        worksheet.columns = [
          {header: 'Контрагент', key: 'contragent', width: 24},
          {header: 'Название объекта', key: 'obj', width: 24},
          {header: 'Cумма договора', key: 'docSum', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Январь', key: 'january', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Февраль', key: 'february', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Март', key: 'marth', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Апрель', key: 'april', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Май', key: 'may', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Июнь', key: 'june', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Июль', key: 'jule', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Август', key: 'august', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Сентябрь', key: 'september', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Октябрь', key: 'october', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Ноябрь', key: 'november', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Декабрь', key: 'december', width: 14.65, style: {numFmt: '#,0.00'}},
          {header: 'Итого', key: 'total', width: 14.65, style: {numFmt: '#,0.00'}},
        ];

        for (const rowPlan of this.planData) {
          const rowDataPlan = {
            ...rowPlan,
          };
          const rowPlanAdd = worksheet.addRow(rowDataPlan);
          rowPlanAdd.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'F8D210'},
          };
          rowPlanAdd.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'}
          };
        }
        const rowPlanTotalAdd = worksheet.addRow(this.totalPlan);
        rowPlanTotalAdd.border = {
          top: {style: 'thin'},
          left: {style: 'thin'},
          bottom: {style: 'thin'},
          right: {style: 'thin'}
        };

        for (const rowFact of this.factData) {
          const rowDataFact = {
            ...rowFact,
          };
          const rowFactAdd = worksheet.addRow(rowDataFact);
          rowFactAdd.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: '81B622'},
          };
          rowFactAdd.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'}
          };
        }
        const rowFactTotalAdd = worksheet.addRow(this.totalFact);
        rowFactTotalAdd.border = {
          top: {style: 'thin'},
          left: {style: 'thin'},
          bottom: {style: 'thin'},
          right: {style: 'thin'}
        };

        const rowDebitAdd = worksheet.addRow(this.debit);
        rowDebitAdd.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: 'EF7C8E'},
        };
        rowDebitAdd.border = {
          top: {style: 'thin'},
          left: {style: 'thin'},
          bottom: {style: 'thin'},
          right: {style: 'thin'}
        };

        for (const rowCost of this.costData) {
          const rowDataCost = {
            ...rowCost,
          };
          const rowCostAdd = worksheet.addRow(rowDataCost);
          rowCostAdd.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'B6E2D3'},
          };
          rowCostAdd.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'}
          };
        }
        const rowCostTotalAdd = worksheet.addRow(this.totalCost);
        rowCostTotalAdd.border = {
          top: {style: 'thin'},
          left: {style: 'thin'},
          bottom: {style: 'thin'},
          right: {style: 'thin'}
        };

        const rowBddsAdd = worksheet.addRow(this.bdds);
        rowBddsAdd.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: 'EF7C8E'},
        };
        rowBddsAdd.border = {
          top: {style: 'thin'},
          left: {style: 'thin'},
          bottom: {style: 'thin'},
          right: {style: 'thin'}
        };

        const buffer = await outBook.xlsx.writeBuffer();
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([buffer], {type: fileType});
        fileWrite(blob, 'MoveMoney.xlsx');
      } catch (e) {
        console.log(e)
      }
    },
    async getReport() {
      try {
        console.log(this.selectContragent, 'selectContragent')
        this.loading = true
        this.normalDate = []
        this.costData = []
        this.factData = []
        this.planData = []
        this.bdds = {
          contragent: 'БАЛАНС БДДС: ',
          obj: '',
          docSum: 0,
          docSumVisible: '',
          january: 0,
          januaryVisible: '',
          february: 0,
          februaryVisible: '',
          marth: 0,
          marthVisible: '',
          april: 0,
          aprilVisible: '',
          may: 0,
          mayVisible: '',
          june: 0,
          juneVisible: '',
          jule: 0,
          juleVisible: '',
          august: 0,
          augustVisible: '',
          september: 0,
          septemberVisible: '',
          october: 0,
          octoberVisible: '',
          november: 0,
          novemberVisible: '',
          december: 0,
          decemberVisible: '',
          total: 0,
          totalVisible: '',
          color: 'success'
        }
        this.totalCost = {
          contragent: '',
          obj: 'Итого',
          docSum: 0,
          docSumVisible: '',
          january: 0,
          januaryVisible: '',
          february: 0,
          februaryVisible: '',
          marth: 0,
          marthVisible: '',
          april: 0,
          aprilVisible: '',
          may: 0,
          mayVisible: '',
          june: 0,
          juneVisible: '',
          jule: 0,
          juleVisible: '',
          august: 0,
          augustVisible: '',
          september: 0,
          septemberVisible: '',
          october: 0,
          octoberVisible: '',
          november: 0,
          novemberVisible: '',
          december: 0,
          decemberVisible: '',
          total: 0,
          totalVisible: '',
          color: 'success'
        }
        this.totalFact = {
          contragent: '',
          obj: 'Итого',
          docSum: 0,
          docSumVisible: '',
          january: 0,
          januaryVisible: '',
          february: 0,
          februaryVisible: '',
          marth: 0,
          marthVisible: '',
          april: 0,
          aprilVisible: '',
          may: 0,
          mayVisible: '',
          june: 0,
          juneVisible: '',
          jule: 0,
          juleVisible: '',
          august: 0,
          augustVisible: '',
          september: 0,
          septemberVisible: '',
          october: 0,
          octoberVisible: '',
          november: 0,
          novemberVisible: '',
          december: 0,
          decemberVisible: '',
          total: 0,
          totalVisible: '',
          color: 'success'
        }
        this.totalPlan = {
          contragent: '',
          obj: 'Итого',
          docSum: 0,
          docSumVisible: '',
          january: 0,
          januaryVisible: '',
          february: 0,
          februaryVisible: '',
          marth: 0,
          marthVisible: '',
          april: 0,
          aprilVisible: '',
          may: 0,
          mayVisible: '',
          june: 0,
          juneVisible: '',
          jule: 0,
          juleVisible: '',
          august: 0,
          augustVisible: '',
          september: 0,
          septemberVisible: '',
          october: 0,
          octoberVisible: '',
          november: 0,
          novemberVisible: '',
          december: 0,
          decemberVisible: '',
          total: 0,
          totalVisible: '',
          color: 'success'
        }
        this.debit = {
          contragent: 'Дебиторка: ',
          obj: '',
          docSum: 0,
          docSumVisible: '',
          january: 0,
          januaryVisible: '',
          february: 0,
          februaryVisible: '',
          marth: 0,
          marthVisible: '',
          april: 0,
          aprilVisible: '',
          may: 0,
          mayVisible: '',
          june: 0,
          juneVisible: '',
          jule: 0,
          juleVisible: '',
          august: 0,
          augustVisible: '',
          september: 0,
          septemberVisible: '',
          october: 0,
          octoberVisible: '',
          november: 0,
          novemberVisible: '',
          december: 0,
          decemberVisible: '',
          total: 0,
          totalVisible: '',
          color: 'red'
        }
        const filterObjToContragent = this.obj.filter((e) => {
          if (e['PROPERTY_1005']) return Object.values(e['PROPERTY_1005'])[0] == this.selectContragent
        })
        const selectObj = filterObjToContragent.map((e) => {
          return e['ID']
        })
        // await this.normalizeDate()
        const method = 'lists.element.get'
        let params = {
          IBLOCK_TYPE_ID: 'lists',
          IBLOCK_ID: '133',
          FILTER: {
            'PROPERTY_1105': selectObj
          }
        }
        let i = 1
        let next = 0
        while (i > 0) {
          console.log('ищем плановые поступления')
          params.start = next
          const reportData = await axios.post(this.url + method, params)
          next = reportData.data.next
          for (const elem of reportData.data.result) {
            const planRow = {
              id: elem['ID'],
              contragent: '',
              obj: '',
              objID: '',
              docSum: 0,
              docSumVisible: '',
              january: 0,
              januaryVisible: '',
              february: 0,
              februaryVisible: '',
              marth: 0,
              marthVisible: '',
              april: 0,
              aprilVisible: '',
              may: 0,
              mayVisible: '',
              june: 0,
              juneVisible: '',
              jule: 0,
              juleVisible: '',
              august: 0,
              augustVisible: '',
              september: 0,
              septemberVisible: '',
              october: 0,
              octoberVisible: '',
              november: 0,
              novemberVisible: '',
              december: 0,
              decemberVisible: '',
              total: 0,
              totalVisible: '',
              color: '',
            }
            const obj = this.obj.filter((e) => {
              return e['ID'] == Object.values(elem['PROPERTY_1105'])[0]
            })[0]
            planRow.obj = obj['NAME']
            planRow.objID = obj['ID']
            if (obj['PROPERTY_1005']) planRow.contragent = Object.values(obj['PROPERTY_1005'])[0]
            if (obj['PROPERTY_881']) {
              planRow.docSum = Number(Object.values(obj['PROPERTY_881'])[0])
              planRow.docSumVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(obj['PROPERTY_881'])[0]))
              this.totalPlan.docSum += Number(Object.values(obj['PROPERTY_881'])[0])
            }
            if (elem['PROPERTY_1107']) {
              planRow.january = Number(Object.values(elem['PROPERTY_1107'])[0])
              planRow.januaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1107'])[0]))
              this.totalPlan.january += Number(Object.values(elem['PROPERTY_1107'])[0])
            }
            if (elem['PROPERTY_1109']) {
              planRow.february = Number(Object.values(elem['PROPERTY_1109'])[0])
              planRow.februaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1109'])[0]))
              this.totalPlan.february += Number(Object.values(elem['PROPERTY_1109'])[0])
            }
            if (elem['PROPERTY_1111']) {
              planRow.marth = Number(Object.values(elem['PROPERTY_1111'])[0])
              planRow.marthVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1111'])[0]))
              this.totalPlan.marth += Number(Object.values(elem['PROPERTY_1111'])[0])
            }
            if (elem['PROPERTY_1113']) {
              planRow.april = Number(Object.values(elem['PROPERTY_1113'])[0])
              planRow.aprilVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1113'])[0]))
              this.totalPlan.april += Number(Object.values(elem['PROPERTY_1113'])[0])
            }
            if (elem['PROPERTY_1115']) {
              planRow.may = Number(Object.values(elem['PROPERTY_1115'])[0])
              planRow.mayVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1115'])[0]))
              this.totalPlan.may += Number(Object.values(elem['PROPERTY_1115'])[0])
            }
            if (elem['PROPERTY_1117']) {
              planRow.june = Number(Object.values(elem['PROPERTY_1117'])[0])
              planRow.juneVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1117'])[0]))
              this.totalPlan.june += Number(Object.values(elem['PROPERTY_1117'])[0])
            }
            if (elem['PROPERTY_1119']) {
              planRow.jule = Number(Object.values(elem['PROPERTY_1119'])[0])
              planRow.juleVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1119'])[0]))
              this.totalPlan.jule += Number(Object.values(elem['PROPERTY_1119'])[0])
            }
            if (elem['PROPERTY_1121']) {
              planRow.august = Number(Object.values(elem['PROPERTY_1121'])[0])
              planRow.augustVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1121'])[0]))
              this.totalPlan.august += Number(Object.values(elem['PROPERTY_1121'])[0])
            }
            if (elem['PROPERTY_1123']) {
              planRow.september = Number(Object.values(elem['PROPERTY_1123'])[0])
              planRow.septemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1123'])[0]))
              this.totalPlan.september += Number(Object.values(elem['PROPERTY_1123'])[0])
            }
            if (elem['PROPERTY_1125']) {
              planRow.october = Number(Object.values(elem['PROPERTY_1125'])[0])
              planRow.octoberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1125'])[0]))
              this.totalPlan.october += Number(Object.values(elem['PROPERTY_1125'])[0])
            }
            if (elem['PROPERTY_1127']) {
              planRow.november = Number(Object.values(elem['PROPERTY_1127'])[0])
              planRow.novemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1127'])[0]))
              this.totalPlan.november += Number(Object.values(elem['PROPERTY_1127'])[0])
            }
            if (elem['PROPERTY_1129']) {
              planRow.december = Number(Object.values(elem['PROPERTY_1129'])[0])
              planRow.decemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1129'])[0]))
              this.totalPlan.december += Number(Object.values(elem['PROPERTY_1129'])[0])
            }
            if (elem['PROPERTY_1131']) {
              planRow.total = Number(Object.values(elem['PROPERTY_1131'])[0])
              planRow.totalVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(Object.values(elem['PROPERTY_1131'])[0]))
              this.totalPlan.total += Number(Object.values(elem['PROPERTY_1131'])[0])
            }
            this.planData.push(planRow)
          }
          if (!next) {
            i = 0
          }
        }

        params = {
          IBLOCK_TYPE_ID: 'lists',
          IBLOCK_ID: '45',
          FILTER: {
            '>=PROPERTY_691': this.normalDate[0],
            '<=PROPERTY_691': this.normalDate[1],
            'PROPERTY_973': selectObj
          }
        }
        i = 1
        while (i > 0) {
          params.start = next
          const reportData = await axios.post(this.url + method, params)
          next = reportData.data.next
          for (const elem of reportData.data.result) {
            if (elem['NAME'] === 'Входящий счет'|| elem['NAME'] === 'Выдача наличных средств' || elem['NAME'] === 'Согласование и оплата расходов (Нал/Безнал)') {
              //console.log(Object.values(elem['PROPERTY_691'])[0].substr(6), 'elem')
              if (elem['PROPERTY_691'] && Object.values(elem['PROPERTY_691'])[0].substr(6) == this.selectYear) {
                console.log(Object.values(elem['PROPERTY_691'])[0].substr(6), 'true elem')
                let costRow = {}
                const costRowObj = this.costData.filter((e) => {
                  return e.objID == Object.values(elem['PROPERTY_973'])
                })[0]
                if (costRowObj) {
                  costRow = costRowObj
                  switch (Object.values(elem['PROPERTY_691'])[0].substr(3, 2)) {
                    case '01':
                      costRow.january += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.january += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '02':
                      costRow.february += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.february += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '03':
                      costRow.marth += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.marth += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '04':
                      costRow.april += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.april += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '05':
                      costRow.may += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.may += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '06':
                      costRow.june += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.june += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '07':
                      costRow.jule += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.jule += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '08':
                      costRow.august += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.august += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '09':
                      costRow.september += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.september += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '10':
                      costRow.october += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.october += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '11':
                      costRow.november += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.november += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '12':
                      costRow.december += Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.december += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                  }
                  costRow.total = costRow.january + costRow.february + costRow.marth + costRow.april + costRow.may + costRow.june+ costRow.jule+ costRow.august + costRow.september + costRow.november + costRow.october + costRow.december

                  costRow.januaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.january))
                  costRow.februaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.february))
                  costRow.marthVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.marth))
                  costRow.aprilVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.april))
                  costRow.mayVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.may))
                  costRow.juneVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.june))
                  costRow.juleVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.jule))
                  costRow.augustVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.august))
                  costRow.septemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.september))
                  costRow.octoberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.october))
                  costRow.novemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.november))
                  costRow.decemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.december))
                  costRow.totalVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.total))
                } else {
                  costRow = {
                    id: elem['ID'],
                    contragent: '',
                    obj: '',
                    objID: '',
                    docSum: 0,
                    docSumVisible: '',
                    january: 0,
                    januaryVisible: '',
                    february: 0,
                    februaryVisible: '',
                    marth: 0,
                    marthVisible: '',
                    april: 0,
                    aprilVisible: '',
                    may: 0,
                    mayVisible: '',
                    june: 0,
                    juneVisible: '',
                    jule: 0,
                    juleVisible: '',
                    august: 0,
                    augustVisible: '',
                    september: 0,
                    septemberVisible: '',
                    october: 0,
                    octoberVisible: '',
                    november: 0,
                    novemberVisible: '',
                    december: 0,
                    decemberVisible: '',
                    total: 0,
                    totalVisible: '',
                    color: '',
                  }
                  const obj = this.obj.filter((e) => {
                    return e['ID'] == Object.values(elem['PROPERTY_973'])[0]
                  })[0]
                  costRow.obj = obj['NAME']
                  costRow.objID = obj['ID']
                  if (obj['PROPERTY_1005']) costRow.contragent = Object.values(obj['PROPERTY_1005'])[0]
                  if (obj['PROPERTY_881']) costRow.docSum = Number(Object.values(obj['PROPERTY_881'])[0])
                  if (obj['PROPERTY_881']) this.totalCost.docSum += Number(Object.values(obj['PROPERTY_881'])[0])
                  switch (Object.values(elem['PROPERTY_691'])[0].substr(3, 2)) {
                    case '01':
                      costRow.january = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.january += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '02':
                      costRow.february = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.february += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '03':
                      costRow.marth = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.marth += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '04':
                      costRow.april = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.april += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '05':
                      costRow.may = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.may += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '06':
                      costRow.june = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.june += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '07':
                      costRow.jule = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.jule += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '08':
                      costRow.august = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.august += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '09':
                      costRow.september = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.september += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '10':
                      costRow.october = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.october += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '11':
                      costRow.november = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.november += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                    case '12':
                      costRow.december = Number(Object.values(elem['PROPERTY_591'])[0])
                      this.totalCost.december += Number(Object.values(elem['PROPERTY_591'])[0])
                      break;
                  }
                  costRow.total = costRow.january + costRow.february + costRow.marth + costRow.april + costRow.may + costRow.june+ costRow.jule+ costRow.august + costRow.september + costRow.november + costRow.october + costRow.december

                  costRow.januaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.january))
                  costRow.februaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.february))
                  costRow.marthVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.marth))
                  costRow.aprilVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.april))
                  costRow.mayVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.may))
                  costRow.juneVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.june))
                  costRow.juleVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.jule))
                  costRow.augustVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.august))
                  costRow.septemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.september))
                  costRow.octoberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.october))
                  costRow.novemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.november))
                  costRow.decemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.december))
                  costRow.totalVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(costRow.total))

                  this.costData.push(costRow)
                }
              }
            }
            if (elem['NAME'] === 'Приход денежных средств ДС') {
              if (elem['PROPERTY_691'] && Object.values(elem['PROPERTY_691'])[0].substr(6) == this.selectYear) {
                let factRow = {}
                const costRowObj = this.factData.filter((e) => {
                  return e.objID == Object.values(elem['PROPERTY_973'])
                })[0]
                if (costRowObj) {
                  factRow = costRowObj
                  switch (Object.values(elem['PROPERTY_691'])[0].substr(3, 2)) {
                    case '01':
                      factRow.january += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.january += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '02':
                      factRow.february += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.february += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '03':
                      factRow.marth += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.marth += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '04':
                      factRow.april += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.april += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '05':
                      factRow.may += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.may += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '06':
                      factRow.june += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.june += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '07':
                      factRow.jule += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.jule += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '08':
                      factRow.august += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.august += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '09':
                      factRow.september += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.september += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '10':
                      factRow.october += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.october += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '11':
                      factRow.november += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.november += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '12':
                      factRow.december += Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.december += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                  }
                  factRow.total = factRow.january + factRow.february + factRow.marth + factRow.april + factRow.may + factRow.june+ factRow.jule+ factRow.august + factRow.september + factRow.november + factRow.october + factRow.december

                  factRow.januaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.january))
                  factRow.februaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.february))
                  factRow.marthVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.marth))
                  factRow.aprilVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.april))
                  factRow.mayVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.may))
                  factRow.juneVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.june))
                  factRow.juleVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.jule))
                  factRow.augustVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.august))
                  factRow.septemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.september))
                  factRow.octoberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.october))
                  factRow.novemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.november))
                  factRow.decemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.december))
                  factRow.totalVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.total))

                } else {
                  factRow = {
                    id: elem['ID'],
                    contragent: '',
                    obj: '',
                    objID: '',
                    docSum: 0,
                    docSumVisible: '',
                    january: 0,
                    januaryVisible: '',
                    february: 0,
                    februaryVisible: '',
                    marth: 0,
                    marthVisible: '',
                    april: 0,
                    aprilVisible: '',
                    may: 0,
                    mayVisible: '',
                    june: 0,
                    juneVisible: '',
                    jule: 0,
                    juleVisible: '',
                    august: 0,
                    augustVisible: '',
                    september: 0,
                    septemberVisible: '',
                    october: 0,
                    octoberVisible: '',
                    november: 0,
                    novemberVisible: '',
                    december: 0,
                    decemberVisible: '',
                    total: 0,
                    totalVisible: '',
                    color: '',
                  }
                  const obj = this.obj.filter((e) => {
                    return e['ID'] == Object.values(elem['PROPERTY_973'])[0]
                  })[0]
                  factRow.obj = obj['NAME']
                  factRow.objID = obj['ID']
                  if (obj['PROPERTY_1005']) factRow.contragent = Object.values(obj['PROPERTY_1005'])[0]
                  if (obj['PROPERTY_881']) factRow.docSum = Number(Object.values(obj['PROPERTY_881'])[0])
                  if (obj['PROPERTY_881']) this.totalFact.docSum += Number(Object.values(obj['PROPERTY_881'])[0])
                  switch (Object.values(elem['PROPERTY_691'])[0].substr(3, 2)) {
                    case '01':
                      factRow.january = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.january += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '02':
                      factRow.february = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.february += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '03':
                      factRow.marth = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.marth += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '04':
                      factRow.april = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.april += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '05':
                      factRow.may = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.may += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '06':
                      factRow.june = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.june += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '07':
                      factRow.jule = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.jule += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '08':
                      factRow.august = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.august += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '09':
                      factRow.september = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.september += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '10':
                      factRow.october = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.october += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '11':
                      factRow.november = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.november += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                    case '12':
                      factRow.december = Number(Object.values(elem['PROPERTY_981'])[0])
                      this.totalFact.december += Number(Object.values(elem['PROPERTY_981'])[0])
                      break;
                  }
                  factRow.total = factRow.january + factRow.february + factRow.marth + factRow.april + factRow.may + factRow.june+ factRow.jule+ factRow.august + factRow.september + factRow.november + factRow.october + factRow.december

                  factRow.januaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.january))
                  factRow.februaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.february))
                  factRow.marthVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.marth))
                  factRow.aprilVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.april))
                  factRow.mayVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.may))
                  factRow.juneVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.june))
                  factRow.juleVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.jule))
                  factRow.augustVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.august))
                  factRow.septemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.september))
                  factRow.octoberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.october))
                  factRow.novemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.november))
                  factRow.decemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.december))
                  factRow.totalVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(factRow.total))

                  this.factData.push(factRow)
                }
              }
            }
          }
          if (!next) {
            i = 0
          }
        }

        const compare = (a, b) => {
          if ( a.obj < b.obj ){
            return -1;
          }
          if ( a.obj > b.obj ){
            return 1;
          }
          return 0;
        }
        this.factData.sort(compare)
        this.costData.sort(compare)
        this.planData.sort(compare)

        this.totalCost.total = this.totalCost.january + this.totalCost.february + this.totalCost.marth + this.totalCost.april + this.totalCost.may + this.totalCost.june+ this.totalCost.jule+ this.totalCost.august + this.totalCost.september + this.totalCost.november + this.totalCost.october + this.totalCost.december
        this.totalCost.januaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.january))
        this.totalCost.februaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.february))
        this.totalCost.marthVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.marth))
        this.totalCost.aprilVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.april))
        this.totalCost.mayVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.may))
        this.totalCost.juneVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.june))
        this.totalCost.juleVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.jule))
        this.totalCost.augustVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.august))
        this.totalCost.septemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.september))
        this.totalCost.octoberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.october))
        this.totalCost.novemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.november))
        this.totalCost.decemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.december))
        this.totalCost.totalVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalCost.total))

        this.totalPlan.total = this.totalPlan.january + this.totalPlan.february + this.totalPlan.marth + this.totalPlan.april + this.totalPlan.may + this.totalPlan.june+ this.totalPlan.jule+ this.totalPlan.august + this.totalPlan.september + this.totalPlan.november + this.totalPlan.october + this.totalPlan.december
        this.totalPlan.januaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.january))
        this.totalPlan.februaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.february))
        this.totalPlan.marthVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.marth))
        this.totalPlan.aprilVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.april))
        this.totalPlan.mayVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.may))
        this.totalPlan.juneVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.june))
        this.totalPlan.juleVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.jule))
        this.totalPlan.augustVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.august))
        this.totalPlan.septemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.september))
        this.totalPlan.octoberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.october))
        this.totalPlan.novemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.november))
        this.totalPlan.decemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.december))
        this.totalPlan.totalVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalPlan.total))

        this.totalFact.total = this.totalFact.january + this.totalFact.february + this.totalFact.marth + this.totalFact.april + this.totalFact.may + this.totalFact.june+ this.totalFact.jule+ this.totalFact.august + this.totalFact.september + this.totalFact.november + this.totalFact.october + this.totalFact.december
        this.totalFact.januaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.january))
        this.totalFact.februaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.february))
        this.totalFact.marthVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.marth))
        this.totalFact.aprilVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.april))
        this.totalFact.mayVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.may))
        this.totalFact.juneVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.june))
        this.totalFact.juleVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.jule))
        this.totalFact.augustVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.august))
        this.totalFact.septemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.september))
        this.totalFact.octoberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.october))
        this.totalFact.novemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.november))
        this.totalFact.decemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.december))
        this.totalFact.totalVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.totalFact.total))

        this.debit.january = this.totalFact.january - this.totalPlan.january
        this.debit.february = this.totalFact.february - this.totalPlan.february
        this.debit.marth = this.totalFact.marth - this.totalPlan.marth
        this.debit.april = this.totalFact.april - this.totalPlan.april
        this.debit.may = this.totalFact.may - this.totalPlan.may
        this.debit.june = this.totalFact.june - this.totalPlan.june
        this.debit.jule = this.totalFact.jule - this.totalPlan.jule
        this.debit.august = this.totalFact.august - this.totalPlan.august
        this.debit.september = this.totalFact.september - this.totalPlan.september
        this.debit.october = this.totalFact.october - this.totalPlan.october
        this.debit.november = this.totalFact.november - this.totalPlan.november
        this.debit.december = this.totalFact.december - this.totalPlan.december
        this.debit.total = this.totalFact.total - this.totalPlan.total

        this.debit.januaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.january))
        this.debit.februaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.february))
        this.debit.marthVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.marth))
        this.debit.aprilVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.april))
        this.debit.mayVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.may))
        this.debit.juneVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.june))
        this.debit.juleVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.jule))
        this.debit.augustVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.august))
        this.debit.septemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.september))
        this.debit.octoberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.october))
        this.debit.novemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.november))
        this.debit.decemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.december))
        this.debit.totalVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.debit.total))

        this.bdds.january = this.totalFact.january - this.totalCost.january
        this.bdds.february = this.totalFact.february - this.totalCost.february
        this.bdds.marth = this.totalFact.marth - this.totalCost.marth
        this.bdds.april = this.totalFact.april - this.totalCost.april
        this.bdds.may = this.totalFact.may - this.totalCost.may
        this.bdds.june = this.totalFact.june - this.totalCost.june
        this.bdds.jule = this.totalFact.jule - this.totalCost.jule
        this.bdds.august = this.totalFact.august - this.totalCost.august
        this.bdds.september = this.totalFact.september - this.totalCost.september
        this.bdds.october = this.totalFact.october - this.totalCost.october
        this.bdds.november = this.totalFact.november - this.totalCost.november
        this.bdds.december = this.totalFact.december - this.totalCost.december
        this.bdds.total = this.totalFact.total - this.totalCost.total

        this.bdds.januaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.january))
        this.bdds.februaryVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.february))
        this.bdds.marthVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.marth))
        this.bdds.aprilVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.april))
        this.bdds.mayVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.may))
        this.bdds.juneVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.june))
        this.bdds.juleVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.jule))
        this.bdds.augustVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.august))
        this.bdds.septemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.september))
        this.bdds.octoberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.october))
        this.bdds.novemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.november))
        this.bdds.decemberVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.december))
        this.bdds.totalVisible = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(Number(this.bdds.total))

        this.loading = false
      } catch
          (e) {
        console.log(e)
      }
    },
    async getObj() {
      try {
        this.obj = []
        const params = {
          IBLOCK_TYPE_ID: 'lists',
          IBLOCK_ID: '97',
        }
        const method = 'lists.element.get'
        let i = 1
        let next = 0
        while (i > 0) {
          params.start = next
          const objData = await axios.post(this.url + method, params)
          next = objData.data.next
          for (const elem of objData.data.result) {
            if (elem.PROPERTY_1005) {
              if (this.contragents.indexOf(Object.values(elem.PROPERTY_1005)[0]) < 0) {
                this.contragents.push(Object.values(elem.PROPERTY_1005)[0])
              }
            }
            this.obj.push(elem)
          }
          if (!next) {
            i = 0
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  mounted() {
    this.getObj()
  }
};
</script>
